import styled from '@emotion/styled'
import arrow from '../../assets/svgs/arrow.svg'

const StyledDiv = styled.div`
  max-width: ${(props) => props.theme.widths[0]};
  margin: 3rem auto 4.5rem;

  border: 1px solid ${(props) => props.theme.colors.orange};
  text-align: center;
  position: relative;
  p {
    font-family: ${(props) => props.theme.fonts.title};
    font-size: ${(props) => props.theme.fontSizes[3]};

    padding: 0.25rem 3rem;
  }
  a {
    text-decoration: none;
    color: ${(props) => props.theme.colors.orange};

    &:hover {
      color: ${(props) => props.theme.colors.lightOrange};
    }
  }
  img {
    position: absolute;
    top: -10px;
    right: -10px;
  }
`

const Link = ({ link }) => {
  return (
    <StyledDiv>
      <a
        href={link?.url}
        rel="noopener noreferrer"
        target="_blank"
        dangerouslySetInnerHTML={{ __html: link?.link_text }}
      ></a>
      <a href={link?.url} rel="noopener noreferrer" target="_blank">
        <img alt="arrow" src={arrow} />
      </a>
    </StyledDiv>
  )
}

export default Link
